import React from "react";

function Pill({ name }: { name: string }) {
  return (
    <div className="uppercase bg-[#817B50] text-white px-[20px] py-[10px] rounded-full text-[16.72px] md:text-[22.48px] md:py-[14.05px] md:px-[28.1px] flex items-center gap-2 md:gap-[7.02px] font-normal leading-[90%]">
      <div className="rounded-full bg-white w-[7.32px] h-[7.32px] md:w-[10px] md:h-[10px]"></div>
      {name}
    </div>
  );
}

export default Pill;
